import type { ManagementType } from "@/mocks/configuracoes";

interface ManagementTypesTableProps {
  types: ManagementType[];
}

const priorityColors: Record<string, string> = {
  "baixa": "bg-primary-50 text-primary-700",
  "média": "bg-caution-50 text-caution-700",
  "alta": "bg-warning-50 text-warning-700",
  "crítica": "bg-danger-50 text-danger-700",
};

export default function ManagementTypesTable({ types }: ManagementTypesTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-background-200">
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Tipo de manejo</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Categoria</th>
            <th className="text-center py-3 px-3 text-xs font-medium text-foreground-500">Exige autorização</th>
            <th className="text-center py-3 px-3 text-xs font-medium text-foreground-500">Exige foto antes/depois</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Prioridade padrão</th>
            <th className="text-center py-3 px-3 text-xs font-medium text-foreground-500">Ativo</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Ações</th>
          </tr>
        </thead>
        <tbody>
          {types.map((t) => (
            <tr key={t.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
              <td className="py-2.5 px-3 text-foreground-900 font-medium">{t.name}</td>
              <td className="py-2.5 px-3 text-foreground-500 text-xs">{t.category}</td>
              <td className="py-2.5 px-3 text-center">
                {t.requiresAuthorization ? <i className="ri-check-line text-primary-600 text-base" /> : <i className="ri-close-line text-foreground-300 text-base" />}
              </td>
              <td className="py-2.5 px-3 text-center">
                {t.requiresPhotoBeforeAfter ? <i className="ri-check-line text-primary-600 text-base" /> : <i className="ri-close-line text-foreground-300 text-base" />}
              </td>
              <td className="py-2.5 px-3">
                <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${priorityColors[t.defaultPriority] || "bg-foreground-100 text-foreground-600"}`}>
                  {t.defaultPriority}
                </span>
              </td>
              <td className="py-2.5 px-3 text-center">
                <span className={`inline-flex w-2.5 h-2.5 rounded-full ${t.active ? "bg-primary-500" : "bg-foreground-300"}`} />
              </td>
              <td className="py-2.5 px-3">
                <button className="w-8 h-8 rounded-lg hover:bg-background-100 flex items-center justify-center text-foreground-400 hover:text-primary-600 transition-colors" title="Editar">
                  <i className="ri-edit-line text-sm" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}